module.exports = __webpack_public_path__ + "r-v3/img/icon-schedule-group_gray.2b3e75a2.svg";